/**
 * The picker — "Raj can ___", stamped into being.
 *
 * Raj's own copy, lightly edited for length (three lines at most on desktop)
 * and grammar. Each `proof` is first person: the sentence above says "Raj
 * can…", the line under it is Raj answering.
 */
export const chips = [
  {
    id: 'experiments',
    label: 'run experiments',
    proof:
      'My CMU capstone was a causal study of 2,800+ Pittsburghers who used re-entry services, using propensity score matching and difference-in-differences to analyze outcomes for graduates. I’ve also done causal analysis with Data Science for Social Good and exploratory analysis at Amazon.',
  },
  {
    id: 'ml',
    label: 'do machine learning',
    proof:
      'At Ray Analytics, I built a custom engine to automatically identify people for our political-analysis Twitter dashboard. At Allianz, I built a legal-document triage model after comparing 600+ model and hyperparameter combinations, cutting review time by about 40%.',
  },
  {
    id: 'backend-scale',
    label: 'ship backend systems at scale',
    proof:
      'I’ve worked on AWS S3’s request path, which handles billions of requests a day. At BlackCloak, I’ve built automated broker removals that process 3.5 million recurring agent-based browser workflows.',
  },
  {
    id: 'learn',
    label: 'learn',
    proof:
      'I studied Computer Science and Math at the University of Florida, then did a Master’s in Public Policy and Management with a focus on data analytics at Carnegie Mellon, going deep on sports analytics, econometrics, and machine learning.',
  },
  {
    id: 'any-scale',
    label: 'work at any scale',
    proof:
      'I’ve worked in big tech (Amazon, Tesla), at traditional firms (GE, Booz Allen), and at startups, from 5 people at Ray Analytics to 100+ at BlackCloak.',
  },
  {
    id: 'startup',
    label: 'run a startup',
    proof:
      'I co-founded Ray Analytics, a political analytics SaaS, and as CTO architected all of it, from the XGBoost classifiers to the backend and website. I’ve also worked with my friends on startups like StayClose, helping carve out the product and make technical decisions.',
  },
  {
    id: 'code-ds',
    label: 'code like a data scientist',
    proof:
      'Across Aires, Allianz, Tesla, and BlackCloak, I’ve used Python (pandas, scikit-learn, NumPy, PyTorch) to test ideas and run experiments, and SQL to pull and shape the data behind them.',
  },
  {
    id: 'code-eng',
    label: 'code like an engineer',
    proof:
      'I’ve built microservices and contributed to monoliths in Java, C++, Ruby, and Python, deployed them on AWS and GCP, and built React frontends on top.',
  },
  {
    id: 'bayesian',
    label: 'build Bayesian models',
    proof:
      'I’ve built Bayesian fixed-effects models on MLB pitch data with brms and Stan, PyMC matchup models for Super Smash Bros., and hierarchical models on company data.',
  },
  {
    id: 'ai',
    label: 'build with AI',
    proof:
      'At BlackCloak, I built the tooling behind our software development lifecycle, lifting engineering throughput by ~110% through consistent code generation and engineer training. I’ve also shipped customer-facing features on frontier models, like automated insights and AI-powered browser workflows.',
  },
  {
    id: 'lead',
    label: 'lead engineering teams',
    proof:
      'At BlackCloak, I’ve been tech lead on several features. At Plainspoken Digital, I led an agile team of seven engineers, and at AWS I led cross-team initiatives.',
  },
];
